/* unplugin-vue-components disabled */import { render } from "./ArtistList.vue?vue&type=template&id=064d3345&scoped=true&ts=true"
import script from "./ArtistList.vue?vue&type=script&lang=ts"
export * from "./ArtistList.vue?vue&type=script&lang=ts"

import "./ArtistList.vue?vue&type=style&index=0&id=064d3345&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064d3345"],['__file',"src/views/artistList/ArtistList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "064d3345"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('064d3345', __exports__)) {
    console.log('reload')
    api.reload('064d3345', __exports__)
  }
  
  module.hot.accept("./ArtistList.vue?vue&type=template&id=064d3345&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('064d3345', render)
  })

}


export default __exports__